import FetchFactory from "vuex-fetch-factory";
import { StateInterface } from "./state";
import {
  OrganisationRaw,
  OrganisationModel
} from "modules/relationprofile/models";
import {
  getOrganisationForCurrentUser,
  getPrivatePersonForCurrentUser
} from "modules/relationprofile/api";
import { PrivatePersonModel, PrivatePersonRaw } from "../models/privatePerson";

const factory = new FetchFactory<StateInterface, {}>();

export default {
  fetchCurrentOrganisation: factory.createSingleFetcher<
    {},
    OrganisationRaw,
    OrganisationModel
  >(
    true,
    "setCurrentOrganisation",
    getOrganisationForCurrentUser,
    (): OrganisationModel => new OrganisationModel()
  ),
  fetchCurrentPrivatePerson: factory.createSingleFetcher<
    {},
    PrivatePersonRaw,
    PrivatePersonModel
  >(
    true,
    "setCurrentPrivatePerson",
    getPrivatePersonForCurrentUser,
    (): PrivatePersonModel => new PrivatePersonModel()
  )
};
